import React from 'react';
import { useAuth } from '../context/AuthContext';
import { ShieldCheck, Users, Music, Activity } from 'lucide-react';

const AdminDashboard = () => {
  const { user } = useAuth();
  const stats = [
    { label: 'Active DJs', value: '248', icon: Users },
    { label: 'Total Mixes', value: '1,842', icon: Music },
    { label: 'Pending Submissions', value: '17', icon: Activity },
    { label: 'Verified Admins', value: '4', icon: ShieldCheck },
  ];

  return (
    <div className="px-6 py-10">
      <div className="flex items-center gap-2 text-orange-400 text-xs font-semibold uppercase tracking-widest">
        <ShieldCheck className="w-4 h-4" /> Super Admin
      </div>
      <h1 className="font-display text-4xl md:text-5xl text-white mt-3">Admin Dashboard</h1>
      <p className="text-neutral-400 mt-2">Signed in as {user?.name} · {user?.email}</p>

      <div className="mt-8 grid grid-cols-2 md:grid-cols-4 gap-4">
        {stats.map(({ label, value, icon: Icon }) => (
          <div key={label} className="rounded-xl border border-white/5 bg-white/[0.03] p-5">
            <div className="w-9 h-9 rounded-full bg-orange-500/15 flex items-center justify-center">
              <Icon className="w-4 h-4 text-orange-400" />
            </div>
            <div className="mt-3 font-display text-3xl text-white">{value}</div>
            <div className="text-xs text-neutral-500 mt-1">{label}</div>
          </div>
        ))}
      </div>

      <div className="mt-10 rounded-xl border border-white/5 bg-white/[0.02] p-6">
        <h2 className="font-display text-2xl text-white">Quick Actions</h2>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-3 mt-4">
          <button className="p-4 rounded-lg border border-white/10 hover:border-orange-500/50 hover:bg-white/[0.05] transition-colors text-left">
            <div className="text-sm text-white font-semibold">Review Submissions</div>
            <div className="text-xs text-neutral-500 mt-1">Approve or reject new artist tracks</div>
          </button>
          <button className="p-4 rounded-lg border border-white/10 hover:border-orange-500/50 hover:bg-white/[0.05] transition-colors text-left">
            <div className="text-sm text-white font-semibold">Manage DJs</div>
            <div className="text-xs text-neutral-500 mt-1">Verify or suspend DJ accounts</div>
          </button>
          <button className="p-4 rounded-lg border border-white/10 hover:border-orange-500/50 hover:bg-white/[0.05] transition-colors text-left">
            <div className="text-sm text-white font-semibold">Publish Mixtape</div>
            <div className="text-xs text-neutral-500 mt-1">Push a new mix to the record pool</div>
          </button>
        </div>
      </div>
    </div>
  );
};

export default AdminDashboard;
